"use client";

import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shadcn-components/ui/dialog";
import { Button } from "@/shadcn-components/ui/button";
import { Input } from "@/shadcn-components/ui/input";
import { Label } from "@/shadcn-components/ui/label";

interface AddTextDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  textValue: string;
  onTextValueChange: (value: string) => void;
  onSubmit: () => void;
}

export function AddTextDialog({
  open,
  onOpenChange,
  textValue,
  onTextValueChange,
  onSubmit,
}: AddTextDialogProps) {
  const handleCancel = () => {
    onOpenChange(false);
    onTextValueChange("");
  };

  const handleSubmit = () => {
    if (textValue.trim()) {
      onSubmit();
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add Text to Chart</DialogTitle>
          <DialogDescription>
            Enter the text you want to display on the chart. You can move and edit it later.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="text" className="text-right">
              Text
            </Label>
            <Input
              id="text"
              value={textValue}
              onChange={(e) => onTextValueChange(e.target.value)}
              className="col-span-3"
              placeholder="Enter your text here..."
              onKeyDown={(e) => {
                if (e.key === "Enter" && textValue.trim()) {
                  handleSubmit();
                }
              }}
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSubmit} 
            disabled={!textValue.trim()}
          >
            Add Text
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
